export class OfflineSyncResponse {
    constructor(savedPayloads) {
        this.savedPayloads = savedPayloads;
    }
}
